import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardProps,
  Heading,
  Link,
  List,
  ListItem,
} from "@chakra-ui/react";

import { CardDivider, DateDisplay } from "@components";
import {
  StepFrontend,
  getComponentDescription,
  getHumanReadableStepName,
} from "@constants";

type ComponentDetailsProps = CardProps & {
  serial: string;
  steps: StepFrontend[];
};

export function ComponentDetails({
  serial,
  steps,
  ...delegated
}: ComponentDetailsProps) {
  const firstStep = steps.sort(
    (stepA, stepB) => Number(stepB.timestamp) - Number(stepA.timestamp),
  )[0];
  return (
    <Card {...delegated}>
      <CardHeader>
        <Heading as="h2">{serial}</Heading>
      </CardHeader>
      <CardDivider />
      <CardBody as={List}>
        <ListItem>
          Component Type: {getComponentDescription(serial ? serial : "")}
        </ListItem>
        <ListItem>
          <Link
            as={ReactRouterLink}
            to={`/modules/${firstStep ? firstStep.moduleId : ""}`}
          >
            Module: {firstStep ? firstStep.moduleId : "Unassigned"}
          </Link>
        </ListItem>
        {firstStep ? (
          <ListItem>
            {`Performed ${getHumanReadableStepName(firstStep.stepName)} `}
            <DateDisplay date={firstStep.timestamp} />
          </ListItem>
        ) : undefined}
      </CardBody>
    </Card>
  );
}
